import { Box, Paper, Typography } from '@mui/material';
import { default as React, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { NotificationContainer } from "react-notifications";
import "react-notifications/lib/notifications.css";
import { useDispatch, useSelector } from 'react-redux';
import UploadImage from './UploadImages';
import './App.css';
import { getData2 } from './features/slices';

function Option22() {

  return (<Box
    className="centered-box" sx={{ width: '100%', p: 3 }}
  >
    <NotificationContainer />
    <UploadImage />
  </Box>
  );
}
export default Option22